import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Modal } from 'react-overlays';
import BaseComponent from '../../baseClasses/BaseComponent';
import animator from '../../helpers/animator';
import TaskCompletionStepsContainer from './TaskCompletionStepsContainer';
import ProjectHeader from '../../containers/TasksContainer/ProjectHeader';
import EditTaskDetails from './EditTaskDetails';
import TaskDetails from './TaskDetails';
import QuickerAssignPopup from '../../components/QuickerAssignPopup';
import dataModel from '../../models/DataModel';
import PageStateDAO from '../../dao/PageStateDAO';
import { PageNames } from '../../constants/ReduxConstants';
import DataSource from '../../dao/DataSource/DataSource';

import AnalyticsLogger from '../../helpers/analytics/analyticsLogger';
import BuildOwnerTaskEdit from './BuildOwnerTaskEdit';
import * as BuildOwnerPermissionsUtil from '../../helpers/permissions/BuildOwnerPermissionsUtil';
import { task_root, project_template_task_root } from  '../../dao/TasksDAO';
import { build_root } from '../../dao/BuildsDAO';
import { task_complete } from '../../dao/TasksDAO';
import { project_template_root } from '../../dao/ProjectTemplatesDAO';
import { project_root } from '../../dao/ProjectsDAO';
import BreadCrumbs from '../../components/BreadCrumbs';
import ProjectTemplateHeader from '../../containers/ProjectTypesContainer/ProjectTemplateHeader';

import closeIcon from '../../assets/images/x.svg';
import './TaskCRUD.scss';
import CopyTaskPopout from '../CopyTaskPopout';
import Input from '../Input';

const task_flat = {
  task: {
    user_task_assignments: {
      user: {
        additionalFields: ['profile_image'],
        companies: {},
      },
    },
    project: {},
  },
};

function formatDate(date) {
  let formattedDate = null;
  if (date) {
    let dateFormatter = new Date(date);
    let month = dateFormatter.getMonth() + 1;
    if (month < 10) {
      month = '0' + month;
    }
    let day = dateFormatter.getDate();
    if (day < 10) {
      day = '0' + day;
    }
    let year = dateFormatter.getFullYear();
    formattedDate = month + '/' + day + '/' + year;
  }
  return formattedDate;
}

export class TaskCRUD extends BaseComponent {

  constructor(props) {
    super(props);
    this.animator = new animator();
    
    this.scrollPosition = 0;
    const currentRole = props.currentUser ? props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });

    const pageName = props.project ? PageNames.PROJECTS_CONTAINER : 'PROJECT_TEMPLATES_CONTAINER';
    const pageState = PageStateDAO.findPageState(pageName);
    this.state = {
      menu: null,
      editing: props.location.pathname.includes('edit'),
      mapExpanded: pageState ? pageState.mapExpanded : false,
      task: null,
      build: null,
      projectTemplate: null,
      projectType: null,
      inventoryItems: [],
      displayCopyPopout: false,
      updatedTaskName: null,
      updatedReferenceDocuments: null,
    };

    this.deleteInventoryItem = this.deleteInventoryItem.bind(this);
    this.fetchTaskBuild = this.fetchTaskBuild.bind(this);
    this.updateInventoryItems = this.updateInventoryItems.bind(this);
    this.hasInventoryChanged = this.hasInventoryChanged.bind(this);
    this.setIsBuildOwner = this.setIsBuildOwner.bind(this);
    this.doDeleteTask = this.doDeleteTask.bind(this);
    this.onSuccessDeletionTask = this.onSuccessDeletionTask.bind(this);
    this.handleDisplayCopyPopout = this.handleDisplayCopyPopout.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.updateEditFlag = this.updateEditFlag.bind(this);
    this.updateReferenceDocument = this.updateReferenceDocument.bind(this);
  }

  componentDidMount() {
    super.componentDidMount();

    if (this.props.params.edit) {
      this.setState({ editing: true });
    }
    // NOTE: added updateTaskAssignments for the task id since task 
    // assignments may affect cc status
    if (this.props.params.task_id)  {
      this.taskDataSource = new DataSource('Task', +this.props.params.task_id, this.props.params.project_id ? task_complete : project_template_task_root, this.handleTaskUpdate);
      this.taskDataSource.get();
     
    }
    if (this.props.params.project_id) {
      this.projectDataSource = new DataSource('Project', +this.props.params.project_id, project_root, this.handleProjectUpdate);
      this.projectDataSource.get();
    }

    if (this.props.params.project_template_id) {
      this.projectTemplateDataSource = new DataSource('ProjectTemplate', +this.props.params.project_template_id, project_template_root, this.handleProjectTemplateUpdate);
      this.projectTemplateDataSource.get();
    }

    if (this.props.params.project_type_id) {
      this.projectTemplateDataSource = new DataSource('ProjectType', +this.props.params.project_type_id, { project_type: {} }, this.handleProjectTypeUpdate);
      this.projectTemplateDataSource.get();
    }
    setTimeout(() => {
      this.handleScrollToTop();
    }, 1000);
  
    if (this.state.projectTemplate && this.state.projectTemplate.published_at && !this.state.readOnly) {
      this.setState({ readOnly: !!this.state.projectTemplate.published_at });
    }

  }

  componentWillUnmount() {
    if (this.taskDataSource) {
      this.taskDataSource.release();
      this.taskDataSource = null;
    }
    if (this.projectDataSource) {
      this.projectDataSource.release();
      this.projectDataSource = null;
    }
    if (this.projectTemplateDataSource) {
      this.projectTemplateDataSource.release();
      this.projectTemplateDataSource = null;
    }
    if (this.projectTypeDataSource) {
      this.projectTypeDataSource.release();
      this.projectTypeDataSource = null;
    }
    if (this.buildDataSource) {
      this.buildDataSource.release();
      this.buildDataSource = null;
    }
  }

  componentDidUpdate(prevProps) {
    const { params } = this.props;
    if (params.task_id && params.task_id != prevProps.params.task_id) {
      if (this.taskDataSource) {
        this.taskDataSource.release();
      }
      this.taskDataSource = new DataSource('Task', +params.task_id, this.props.params.project_id ? task_complete : project_template_task_root, this.handleTaskUpdate);
      this.taskDataSource.get();
      setTimeout(() => { 
        this.handleScrollToTop();
      }, 1000);
    }
    if (params.project_id && params.project_id != prevProps.params.project_id) {
      if (this.projectDataSource) {
        this.projectDataSource.release();
      }
      this.projectDataSource = new DataSource('Project', +params.project_id, project_root, this.handleProjectUpdate);
      this.projectDataSource.get();
    }

    if (params.project_template_id && params.project_template_id != prevProps.params.project_template_id) {
      if (this.projectTemplateDataSource) {
        this.projectTemplateDataSource.release();
      }
      this.projectTemplateDataSource = new DataSource('ProjectTemplate', +params.project_template_id, project_template_root, this.handleProjectTemplateUpdate);
      this.projectTemplateDataSource.get();
    }

    if (params.project_type_id && params.project_type_id != prevProps.params.project_type_id) {
      if (this.projectTypeDataSource) {
        this.projectTypeDataSource.release();
      }
      this.projectTypeDataSource = new DataSource('ProjectType', +params.project_type_id, { project_type: {} }, this.handleProjecxtTypeUpdate);
      this.projectTypeDataSource.get();
    }

    if (this.state.projectTemplate && this.state.projectTemplate.published_at && !this.state.readOnly) {
      this.setState({ readOnly: !!this.state.projectTemplate.published_at });
    }

    if(this.state.editing && this.state.readOnly){
      const path = this.props.location.pathname;
      const updatedPath = path.substring(0, path.lastIndexOf('/edit'));
      if(updatedPath){
        this.props.history.push(updatedPath);
        this.setState({ editing: false });
      }
    }
  }

  handleTaskUpdate(task, action, acData) {
    if (task) {
      if (acData && this.state.amEditinTask) {
        task.name = this.state.task.name;
      }

      this.fetchTaskBuild(task);
      if (action == 'cancelEdit') {
        this.setState({ editing: false, task });
      }
      else {
        this.setState({ task });
      }
      if(!this.state.updatedTaskName){
        this.state.updatedTaskName = this.state.task && this.state.task.name;
      }
    }
  }

  handleBuildUpdate(build, action, acData) {
    if (build) {
      this.setState({ build });
      if (build.buildable_type == 'ProjectTemplate') {
        if (!this.state.projectTemplate || this.state.projectTemplate.id != build.buildable_id) {
          if (this.projectTemplateDataSource) {
            this.projectTemplateDataSource.release();
          }
          this.projectTemplateDataSource = new DataSource('ProjectTemplate', build.buildable_id, project_template_root, this.handleProjectTemplateUpdate);
          this.projectTemplateDataSource.get();
        }
      }
    }
  }

  handleProjectUpdate(project, action, acData) {
    if (project) {
      this.setState({ project });
      this.handleSetupInventory();
    }
  }

  handleProjectTemplateUpdate(projectTemplate, action, acData) {
    if (projectTemplate) {
      this.setState({ projectTemplate, rojectType: projectTemplate.project_type });
      this.handleSetupInventory();
    }
  }

  handleProjectTypeUpdate(projectType, action, acData) {
    if (projectType) {
      this.setState({ projectType });
      this.handleSetupInventory();
    }
  }

  fetchTaskBuild(task) {
    if (task) {
      if (!this.state.build || task.build_id != this.state.build.id) {
        if (this.buildDataSource) {
          this.buildDataSource.release();
        }
        this.buildDataSource = new DataSource('Build', task.build_id, build_root, this.handleBuildUpdate);
      }
    }
    this.buildDataSource.get();
  }

  handleSetupInventory() {
    const { currentCompany } = this.props;
    this.inventoryEnabled = currentCompany.features && currentCompany.features.inventory && currentCompany.features.inventory.enabled;
    if (this.inventoryEnabled) {
      this.updateInventoryItems();
    }
    if (this.refs && this.refs.task_crud_body) {
      this.refs.task_crud_body.scrollTop = this.scrollPosition;
      if (this.state.task.forCreate) {
        this.state.task.forCreate = false;
        this.setState({ editing: true, amEditinTask: true });
      }
      this.refs.task_crud_body.scrollTop = this.scrollPosition;
    }
  }

  handleScrollToTop() {
    if (this.state.task) {
      let element = document.getElementById('task-crud-internal-scroller-' + this.state.task.id);
      let scrollElement = document.getElementById('task-crud-scroller-' + this.state.task.id);
      if (element) {
        this.scrollPosition = 0;
        scrollElement.scrollTo(0, 0);
        scrollElement.scrollTop = 0;
      }
    }
  }

  updateInventoryItems() {
    const { task } = this.state;
    if (task) {
      const inventoryItems = task.inventory_items ?
        task.inventory_items.map(
          inventoryItem => {
            return {
              customer_data: inventoryItem.customer_data,
              id: inventoryItem.id,
              identifier: inventoryItem.identifier,
              name: inventoryItem.inventory.name,
              'created_at': '10:00pm',
            };
          
          }
        )
        : [];
      // Compare states before updating
      if (this.hasInventoryChanged(this.state.inventoryItems, inventoryItems)) {
        this.setState({ inventoryItems });
      }
    }
  }

  hasInventoryChanged(oldItems, newItems) {
    if (oldItems.length != newItems.length) {
      return true;
    }
    const differentItems = new Map();
    for (let oldItem of oldItems) {
      differentItems.set(oldItem.id, oldItem);
    }
    for (let newItem of newItems) {
      if (!differentItems.has(newItem.id)) {
        return true;
      }
      else {
        // the ID is in both old and new items
        const oldItem = differentItems.get(newItem.id);
        if (oldItem.name != newItem.name || oldItem.identifier != newItem.identifier) {
          return true;
        }
      }
    }
    return false;
  }

  setIsBuildOwner() {
    const { build } = this.state;
    if (build) {
      this.isBuildOwner = BuildOwnerPermissionsUtil.isBuildOwnerOfBuild(build, this.props.currentUser.id);
    }
  }

  handleExpansion(height) {
    if (this.props.closeMap) {
      this.props.closeMap(height > 20);
    }
    const expandedValue = height > (this.state.project ? 65 : 0) ? true : false;
    PageStateDAO.setPageStateEntry(PageNames.PROJECTS_CONTAINER, 'mapExpanded', expandedValue);
    this.setState({ mapExpanded: expandedValue });
  }
  
  deleteInventoryItem(inventoryItem) {
    const { task } = this.state;
    dataModel.showGlobalModal('SYSTEM_POPUP', {
      message: 'Are you sure you want to delete inventory item ' + inventoryItem.name + '? This action cannot be undone.',
      captionText: 'WARNING',
      height: 184,
      width: 320,
      cancelButtonText: 'CANCEL',
      okButtonText: 'YES',
      handleOwnerOk: () => {
        dataModel.inventoryItemsDAO.deleteInventoryItem(inventoryItem, task.id).then(updatedTask => {
          if (updatedTask) {
            if (this.state.amEditinTask) {
              updatedTask.name = this.state.task.name;
            }
            this.setState({ task: updatedTask });
          }
        });
      },
    });
  }

  onSuccessDeletionTask(build_id){
    const { task, project, projectTemplate } = this.state;
    if (this.props.handleTaskDeleted) {
      this.props.handleTaskDeleted(task.id);
    }
    if (projectTemplate) {
      this.props.history.push('/project-types/' + projectTemplate.project_type_id + '/project-template/' + projectTemplate.id + '/build/' + build_id);
    }
    else {
      this.props.history.push('/projects/' + project.id + '/build/' + build_id);
    }
  }

  doDeleteTask() {
    const { task } = this.state;
    dataModel.tasksDAO.deleteTask(task.id, null, this.onSuccessDeletionTask);
  }

  handleTaskDelete() {
    const message = 'Are you sure you want to delete ' + this.state.task.name + '? This action cannot be undone.';

    dataModel.showGlobalModal('SYSTEM_POPUP', {
      message: message,
      cancelButtonText: this.textMap.cancel.toUpperCase(),
      okButtonText: this.textMap.yes.toUpperCase(),
      width: 300,
      height: 175,
      handleOwnerOk: () => {
        this.doDeleteTask();
      },
    });
  }

  handleEditCallBack(editedTask) {
    if (this.state.amEditinTask) {
      editedTask.name = this.state.task.name;
    }
    this.setState({ amEditinTask: true });
    this.setState({ task: Object.assign({}, editedTask) });
  }

  handleBuildOwnerTaskSave(op1, op2, editedTask, bulkAssignRoute) {
    const { currentUser } = this.props;
    if(editedTask && editedTask.name.length == 0){
      dataModel.displayWarnErrorMessage(
        'Task name should not be empty',
        4000,
        2
      );
      return null;
    }

    if (bulkAssignRoute) {
      dataModel.showGlobalModal('SYSTEM_POPUP', {
        message: 'You have selected a user who is not part of your company. Would you like to continue?',
        cancelButtonText: 'NO',
        okButtonText: 'CONTINUE',
        width: 320,
        height: 182,
        handleOwnerOk: () =>  {
          bulkAssignRoute();
        },
      });
    } else {
      let updateTask = Object.assign({}, this.state.task);

      const usersNotFromBuildOwnerCompany = updateTask.user_task_assignments.find(uta => {
        return (uta.toBeAdded || uta.toBeDeleted) && uta.user.companies[0].id != currentUser.companies[0].id;
      });

      if (usersNotFromBuildOwnerCompany && !this.props.currentUser.super_admin) {
        dataModel.showGlobalModal('SYSTEM_POPUP', {
          message: 'You have selected one or more users who are not part of your company. Would you like to continue?',
          cancelButtonText: 'NO',
          okButtonText: 'CONTINUE',
          width: 320,
          height: 182,
          handleOwnerOk: () =>  {
            this.handleTaskSave();
          },
        });
      }
      else {
        this.handleTaskSave(editedTask);
      }
    }
  }

  handleTaskSave(editedTask) {
    const { updatedReferenceDocuments, task } = this.state;
    let updateTask = Object.assign({}, task);
    if(updateTask && updateTask.name.length == 0){
      dataModel.displayWarnErrorMessage(
        'Task name should not be empty',
        4000,
        2
      );
      return null;
    }
    if(updatedReferenceDocuments){
      const referenceDocsToAddList = updatedReferenceDocuments.filter(rd => {
        return rd.toBeAdded;
      });
      referenceDocsToAddList.map(referenceDoc=>{
        dataModel.tasksDAO.addReferenceDocument(referenceDoc.id, this.state.task.id, referenceDoc, { recordDescriptor: this.props.project ? task_root : project_template_task_root }).then((response) => {
          delete referenceDoc.toBeAdded;
        });
      });

      const referenceDocsToRemoveList = task.reference_documents.filter(urd => !updatedReferenceDocuments.some(rd => rd.id === urd.id));
      referenceDocsToRemoveList.map(referenceDoc=>{
        dataModel.tasksDAO.removeReferenceDocument(referenceDoc.id, this.state.task.id, null, { recordDescriptor: this.props.project ? task_root : project_template_task_root });
      });
    }
    if (updateTask.date && updateTask.time) {
      updateTask.due_date = new Date(updateTask.date + ' ' + updateTask.time);
    }
    else if (updateTask.due_date) {
      if (updateTask.time) {
        //get date
        let d = new Date(updateTask.due_date);
        updateTask.due_date = new Date(d.getFullYear() + '/' + (d.getMonth() + 1) + '/' + d.getDate() + ' ' + updateTask.time);
      }
      else if (updateTask.date) {
        //get time
        let d = new Date(updateTask.due_date);
        let hours = d.getHours();
        if (hours < 10) {
          hours = '0' + hours;
        }

        updateTask.due_date = new Date(updateTask.date + ' ' + hours + ':00:00');
      }
    }
    else if (updateTask.date) {
      updateTask.due_date = new Date(updateTask.date + ' 00:00:00');
    }

    if (updateTask.user_task_assignments) {
      const assignmentEventLabels = {
        'field_user': 'TaskAssigned - Assigned To',
        'reviewer': 'TaskAssigned - Reviewer',
        'approver': 'TaskAssigned - Approver',
      };
      for (let assignment of updateTask.user_task_assignments) {
        if (assignment.toBeAdded && assignmentEventLabels[assignment.assignment_type]) {
          this.analyticsLogger.logTaskAdminEvent(assignmentEventLabels[assignment.assignment_type]);
        }
      }
    }

    if (updateTask.id) {
      const assignmentsToUpdate = !updateTask.user_task_assignments ? false : updateTask.user_task_assignments.filter(uta => { return uta.toBeAdded || uta.toBeDeleted; }).length > 0;
      if (this.state.project && assignmentsToUpdate) {
        dataModel.tasksDAO.updateTaskAssignments(updateTask, { recordDescriptor: { task: {
          user_task_assignments: {
            user: { additionalFields: ['profile_image'], 
              companies: {},
            },
          },
          event_histories: { activity: {}, activity_sub_type: {}, user_who_performed_action: {} },
        } } }).then((task) => {
          this.taskDataSource.get();
        });
      }
      else {
        dataModel.tasksDAO.updateTask(updateTask, null, { recordDescriptor: { task: { event_histories: { activity: {}, activity_sub_type: {}, user_who_performed_action: {} } } } }).then((task) => {
          this.taskDataSource.get();
        });
      }
    }
    else {
      dataModel.tasksDAO.createTask(updateTask, null, { recordDescriptor: { task: {} } }).then(() => this.editedTask = null).then(task => {
        this.setState({ task });
      });
    }
    this.setState({ amEditinTask: false, editing: false });
    dataModel.dataChanged = false;
    this.state.updatedTaskName = this.state.task.name;
  }

  handleClick(){
    this.setState({ displayCopyPopout: false });
  }

  handleDisplayCopyPopout(e) {
    if (e) e.stopPropagation();
    const { displayCopyPopout } = this.state;
    this.setState({ displayCopyPopout: !displayCopyPopout });
  }

  handleCopyTask(){
    dataModel.displayInfoErrorMessage('The task was copied successfully.', 4000, 1);
  }
  handleTaskEdit() {
    this.setState({ editing: true });
    this.handleScrollToTop();
  }

  async handleCancel() {
    this.taskDataSource.get('cancelEdit');
    this.handleScrollToTop();
    if(this.state.amEditinTask){
      this.setState({ amEditinTask: false });
    }
  }
  
  handleChangeName(e)
  {
    if(e.target.value.trim() !== '' || !e.target.value){
      let task = Object.assign({}, this.state.task, { name: e.target.value });
      this.setState({ task, amEditinTask: true });
      dataModel.dataChanged = true;
    }
  }

  handleScroll(e) {
    e.preventDefault();
    if (this.refs && this.refs.task_crud_body) {
      this.scrollPosition = this.refs.task_crud_body.scrollTop;
    }
  }
  
  updateEditFlag(flag){
    this.setState({ amEditinTask: flag });
  }

  updateReferenceDocument(editReferenceDocuments){
    this.setState({ updatedReferenceDocuments: editReferenceDocuments });
  }

  handleDisplayQuickerAssign(project, isVendorBuildOwner, quickAssignUser) {
    this.setState({ displayQuickerAssignPopup: project, isVendorBuildOwner, quickAssignUser });
  }

  handleCloseQuickerAssign() {
    this.setState({ displayQuickerAssignPopup: null });
  }

  render() {
    const { permissions } = this.props;
    const { task, build, project, projectTemplate, updatedReferenceDocuments, readOnly } = this.state;
    if (!task) {
      return null;
    }

    const { editing, inventoryItems } = this.state;
    
    let leftColumn; 
    let rightColumn = null;

    let templateHeader = null;
    if (this.state.projectTemplate) {
      templateHeader = <ProjectTemplateHeader
        history={this.props.history}
        projectTemplate={this.state.projectTemplate}
        projectType={this.state.projectType}
        currentCompany={this.props.currentCompany}
        currentUser={this.props.currentUser}
    />;

    }

    let quickerAssignContainer = null;
    if (this.state.displayQuickerAssignPopup) {
      quickerAssignContainer =
        (
        <Modal show={true}>
          <QuickerAssignPopup
            projectId={this.state.displayQuickerAssignPopup.id}
            buildId={task.build_id}
            handleClosePopup={this.handleCloseQuickerAssign}
            isVendorBuildOwner={this.state.isVendorBuildOwner}
            selectedUser={this.state.quickAssignUser}
            currentCompany={this.props.currentCompany}
            currentUser={this.props.currentUser}
          />
          </Modal>
        );
    }

    this.setIsBuildOwner();   
    if (editing && (permissions.canEditTask || this.isBuildOwner)) {   
      const buildOwnerEditing = editing && !permissions.canEditTask && this.isBuildOwner ? true : false;  
      leftColumn = 
        <TaskCompletionStepsContainer 
          pmCanEdit={permissions.canEditTask}
          task={task} 
          editing={permissions.canEditTask} 
          project={project}
          projectTemplate={projectTemplate}
          userProject={project}
          build={build}
          isBuildOwner={this.isBuildOwner}
          buildOwnerEditing={buildOwnerEditing}
          view={projectTemplate ? 'projectTemplates' : 'projects'}
        />;

      if (this.isBuildOwner && !this.props.permissions.canEditTask) {
        rightColumn =
            <BuildOwnerTaskEdit
              id={'task-settings-' + task.id}
              task={task}
              project={project}
              build={build}
              editing={editing}
              deleteTask={this.handleDeleteTask}
              editCallBack={this.handleEditCallBack}
              handleTaskSave={this.handleTaskSave}
            />;
      }
      else {
        rightColumn =
          <EditTaskDetails
            id={'task-settings-' + task.id}
            task={task}
            project={project}
            projectTemplate={projectTemplate}
            editing={editing}
            updateReferenceDocument={this.updateReferenceDocument}
            updatedReferenceDocuments={updatedReferenceDocuments}
            updateEditFlag={this.updateEditFlag}
            deleteTask={this.handleDeleteTask}
            editCallBack={this.handleEditCallBack}
            handleTaskSave={this.handleTaskSave}
            inventoryItems={inventoryItems}
            inventoryEnabled={this.inventoryEnabled}
            deleteInventoryItem={this.deleteInventoryItem}
          />;
      }
    }
    else {
      leftColumn = 
        <TaskCompletionStepsContainer 
          task={task} 
          editing={editing} 
          project={project} 
          projectTemplate={projectTemplate}
          userProject={project} 
          pmCanEdit={permissions.canEditTask} 
          build={build} 
          isBuildOwner={this.isBuildOwner}
          view={projectTemplate ? 'projectTemplates' : 'projects'}
        />;
      rightColumn = 
        <TaskDetails 
          id={'task-settings-' + task.id} 
          task={task} 
          project={project} 
          projectTemplate={projectTemplate}
          build={build} 
          editCallBack={this.isBuildOwner && this.handleEditCallBack}
          inventoryItems={inventoryItems}
          inventoryEnabled={this.inventoryEnabled}
        />;
    }
    const saveHandler = this.state.amEditinTask && this.isBuildOwner ? this.handleBuildOwnerTaskSave : this.state.amEditinTask ? this.handleTaskSave : null;

    let buttons = null;
    if (editing && (permissions.canEditTask || this.isBuildOwner)) {
      buttons = <div className={'button-list'}>
        <div className={'cancel-button button'} onClick={this.handleCancel}>
          <img src={closeIcon} alt="close-button"></img>
        </div>
        <div className={'save-button button' + (!this.state.amEditinTask ? ' disabled' : '')} onClick={saveHandler}>{this.textMap.save.toUpperCase()}</div>
      </div>;  
    }
    else if ((permissions.canEditTask || this.isBuildOwner) && !readOnly) {
      buttons = <div className={'button-list'}>
        {this.props.permissions.canDeleteTask && <div className={'delete-button button' + (this.props.permissions.canDeleteTask && !task.id ? ' disabled' : '')}
          onClick={this.handleTaskDelete}></div>}
        {(this.props.permissions.canEditTask || this.isBuildOwner) && <div className={'edit-button button'} onClick={this.handleTaskEdit}></div>}
      </div>;  
    }
    let taskHeader = null;
    let taskDate = null;
    if (task.estimated_completion_date || task.actual_completion_date) {
      let calendarIcon = null;
      let taskCompletion = null;
      let estimatedCompletionDate = formatDate(task.actual_completion_date ? task.actual_completion_date : task.estimated_completion_date);
      const overdue = !task.actual_completion_date && new Date(estimatedCompletionDate) < new Date() ? ' overdue' : '';
      const completed = task.status == 'not_started' || task.status == 'in_progress' ? '' : ' completed';
      calendarIcon = <div className={'calendar-icon' + overdue + completed} />;

      taskCompletion = <div className={'icon-text' + overdue}>{estimatedCompletionDate}</div>;
      const whichDatePopup = <div className="which-date-popup">{task.actual_completion_date ? 'Actual Completion Date' : 'Projected Completion Date'}</div>;

      taskDate = <div className='completion-date'>
        {calendarIcon}
        {taskCompletion}
        {whichDatePopup}
      </div>;
    }

    if (project) {
      let completed = 0;
      let total = 0;
      if (task.completion_criteria_counts) {
        total = task.completion_criteria_counts.total;
        completed = task.completion_criteria_counts.completed;
      }
      let attachmentCount = task.task_attachments_count;
  
      let statusName = task.status && task.status.split('_').map(word => word ? word.substr(0, 1).toUpperCase() + word.substr(1).toLowerCase() : '').join(' ');
      let statusStyle = '';
  
      switch (task.status) {
      case 'not_started':
        statusStyle = 'not-started';
        break;
      case 'in_progress':
        statusStyle = 'in-progress';
        break;
      case 'pending_review':
        statusStyle = 'pending';
        break;
      case 'pending_approval':
        statusStyle = 'pending';
        break;
      case 'completed':
        statusStyle = 'completed';
        break;
      default: break;
      }
  
      let taskStatus = <div className={'task-status ' + statusStyle}>
        {statusName}
      </div>;
      
      taskHeader = <div className="task-header">
        <div className="top-line">
          {(editing && permissions.canEditTask) ? <Input className="task-title editing" value={task ? task.name : ''} onChange={this.handleChangeName} /> :
            <div className="task-title">{task.name && task.name}</div>
          }
          {buttons}
        </div>
        {!editing ?
          (<div className="info-icon-row">
            <div className="attachments">
              <div className="attachment-icon" />
              <div className="icon-text">{attachmentCount}</div>
            </div>
            <div className="completion-criteria">
              <div className="completion-icon" />
              <div className="icon-text">{completed + '/' + total}</div>
            </div>
            {taskDate}
            {taskStatus}
          </div>) : (<div></div>)}
      </div>;
      
    }
    else {
      taskHeader = <div className="task-header"> 
        <div className="top-line">
          {(editing && permissions.canEditTask) ? <Input className="task-title editing" value={task ? task.name : ''} onChange={this.handleChangeName} /> :
            <div className="task-title">{task.name && task.name}</div>
          }
          {buttons}
        </div>
        <div className="info-icon-row" />
      </div>;
    }

    return (
      <div className={'task-crud' + (project ? ' task-crud--with-project' : '')}>
        <CopyTaskPopout 
            task={this.state.task} 
            handleClosePopup={this.handleDisplayCopyPopout}
            displayCopyPopout={this.state.displayCopyPopout}
            handleAddCopiedTask={this.handleCopyTask}
            currentUser={this.props.currentUser}
            isFromTaskCRUD={true}
            className={'task-crud-copy-popout'}
            />
        {quickerAssignContainer}
        {templateHeader}
        {project &&
          <ProjectHeader
            currentCompany={this.props.currentCompany}
            projectId={+this.props.params.project_id}
            task={this.state.task}
            build={this.state.build}
            type='tasks-page'
            handleExpansion={this.handleExpansion}
            mapExpanded={this.state.mapExpanded}
            permissions={this.props.permissions}
            new_projects={this.props.new_projects}
            inProjectsTab={true}
            updateProject={this.props.updateProject}
            handleBuildOwnerTaskSave={this.handleBuildOwnerTaskSave}
            displayQuickerAssign={this.handleDisplayQuickerAssign}
            isLeftDividerHide={true}
            />}
        <div className="task-crud-container">
        <div className="task-crud-subheader">
            <BreadCrumbs history={this.props.history} fromTasks={false} taskName={this.state.updatedTaskName ? this.state.updatedTaskName : task.name}/>
          </div>
          {taskHeader}  
        {this.state.menu}
          <div id={'task-crud-scroller-' + task.id} className={'task-crud-scroller' + (this.state.mapExpanded ? ' display-map' : '') + (project ? ' task-crud-scroller--with-project' : '')} ref="task_crud_body" onScroll={this.handleScroll}>
          <div className="task-crud-body" id={'task-crud-internal-scroller-' + task.id} >
            <div className="column column-1">
              {leftColumn}
            </div>
              <div className="column-divider" />
            <div className="column column-2">
              {rightColumn}
            </div>
          </div>
          </div>
        </div>  
      </div>
    );
  }
}

// Change to appropriate class name

const mapStateToProps = (state, ownProps) => {
  return {
    permissions: state.new_users.permissions,
    currentUser: state.new_users.currentUser,
    currentCompany: state.new_companies.currentCompany,
  };
};

export default withRouter(connect(mapStateToProps)(TaskCRUD));



// WEBPACK FOOTER //
// ./src/components/TaskCRUD/index.js